import React, { useState } from 'react';

import { Checkbox, Grid, IconButton, Input, InputAdornment, ListItemText, makeStyles, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import OrderStatusCell from './OrderStatusCell';
import { orderTrackingColors, orderTrackingStatuses } from '../../models/Order';

const useStyles = makeStyles((theme) => ({
  chkBoxSvg: {
    '& path': {
      outline: '3px solid rgba(0, 0, 0, 0.54)',
    },
  },
  list: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  menu: {
    border: '2px solid #E7E7E7',
    borderRadius: '5px',
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    paddingBottom: '1rem',
  },
}));

const statuses = { ...orderTrackingStatuses };
const getSelectedLabel = (selected) => {
  if (!selected.length) return 'No order';
  if (selected.length === Object.keys(statuses).length) return 'All orders';
  if (selected.length <= 2) return selected.map((sl) => statuses[sl].label).join(' and ');
  return `${statuses[selected[0]].label} + ${selected.length - 1} statuses`;
};

export default ({ onCriteriaChange }) => {
  const classes = useStyles();
  const [selectedFilter, setSelectedFilter] = useState(['demo', 'registered', 'paid', 'complete', 'cancelled']);
  const [keyword, setKeyword] = useState('');
  const onFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    const status = event.target.value;
    onCriteriaChange({ isDueSoon: null, status });
  };
  const onSearchChange = (event) => {
    setKeyword(event.target.value);
  };
  const onSearchClick = () => {
    onCriteriaChange({ keyword });
  };

  const renderFilterDropdown = () => {
    return (
      <Grid container item alignItems="center" justify="flex-start" xs={6}>
        <Typography>View:&nbsp;</Typography>
        <Select
          multiple
          displayEmpty
          value={selectedFilter}
          onChange={onFilterChange}
          input={<Input disableUnderline />}
          renderValue={getSelectedLabel}
          MenuProps={{
            anchorOrigin: {
              horizontal: 'left',
              vertical: 'bottom',
            },
            classes: {
              list: classes.list,
              paper: classes.menu,
            },
            getContentAnchorEl: null,
          }}>
          {['demo', 'registered', 'paid', 'complete', 'cancelled', 'archived'].map((key) => {
            const status = statuses[key];
            const isChecked = selectedFilter.includes(status.value);
            return (
              <MenuItem key={status.value} value={status.value} style={{ background: 'none', paddingBottom: 0, paddingTop: 0, width: '230px' }}>
                <Checkbox checked={isChecked} color="primary" />
                {key === 'all' ? <ListItemText primary={status.label} /> : <OrderStatusCell color={orderTrackingColors[status.value]} status={status.label} />}
              </MenuItem>
            );
          })}
        </Select>
      </Grid>
    );
  };

  const renderSearchInput = () => (
    <Grid item container xs={6} justify="flex-end">
      <TextField
        onChange={onSearchChange}
        onKeyUp={(evt) => {
          if (evt.key === 'Enter') {
            onSearchClick();
          }
        }}
        placeholder="Search"
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <IconButton onClick={onSearchClick}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        type="text"
      />
    </Grid>
  );

  return (
    <Grid container justify="space-between">
      {renderFilterDropdown()}
      {renderSearchInput()}
    </Grid>
  );
};
